import React from "react";
import { StoreFunctions } from "../context/Store";

import "../../assets/styles/TextArea.scss";

export interface TextAreaProps {
  label: string;
  name: string;
  value: string;
  onChange: StoreFunctions["setAbout"];
}

export interface TextAreaState {}

export const TextArea = (props: TextAreaProps) => {
  const { label, name, value, onChange } = props;
  return (
    <div className="text-area mb-5">
      <label htmlFor={name}>{label}</label>
      <div className="text-area-wrapper">
        <textarea
          rows={10}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        ></textarea>
      </div>
    </div>
  );
};

export default TextArea;
